import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-input-money-type',
  templateUrl: './input-money-type.component.html',
  styleUrls: ['./input-money-type.component.css']
})
export class InputMoneyTypeComponent extends FieldType {}
